// PostHog feature flag keys. Values must match the flag keys in PostHog.
// Usage: isPostHogFlagEnabled(POSTHOG_FLAGS.INTEGRATED_PYLON_WIDGET)
export const POSTHOG_FLAGS = {
  INTEGRATED_PYLON_WIDGET: 'integrated-pylon-widget',
}
